import { storeToRefs } from "pinia";
import { useAllGoalsStore } from "@/stores/WheelAnalysis/allGoals";


export default {


    name: "WheelLegend",
    components: {},
    mixins: [],
    props: {},

    setup() {
        const allGoalsStore = useAllGoalsStore();
        const { selectedTargets } = storeToRefs(allGoalsStore);
        const { selectedGoals } = storeToRefs(allGoalsStore);

        return { selectedTargets, selectedGoals };
    },

    data() {
        return {
            goalColors: [
                "#e4243c", "#dcac3c", "#4c9c3c", "#c41c2c", "#fc3c24",
                "#26bde2", "#fcc30b", "#a41c44", "#fd6925", "#dd1367",
                "#fd9d24", "#bf8b2e", "#3f7e44", "#0a97d9", "#56c02b",
                "#00689d", "#19486a"
            ],

            // IDs + numbers only. Labels come from i18n.
            goals: [
                { id: "1", targets: ["1.1","1.2","1.3","1.4","1.5","1.a","1.b"] },
                { id: "2", targets: ["2.1","2.2","2.3","2.4","2.5","2.a","2.b","2.c"] },
                { id: "3", targets: ["3.1","3.2","3.3","3.4","3.5","3.6","3.7","3.8","3.9","3.a","3.b","3.c","3.d"] },
                { id: "4", targets: ["4.1","4.2","4.3","4.4","4.5","4.6","4.7","4.a","4.b","4.c"] },
                { id: "5", targets: ["5.1","5.2","5.3","5.4","5.5","5.6","5.a","5.b","5.c"] },
                { id: "6", targets: ["6.1","6.2","6.3","6.4","6.5","6.6","6.a","6.b"] },
                { id: "7", targets: ["7.1","7.2","7.3","7.a","7.b"] },
                { id: "8", targets: ["8.1","8.2","8.3","8.4","8.5","8.6","8.7","8.8","8.9","8.10","8.a","8.b"] },
                { id: "9", targets: ["9.1","9.2","9.3","9.4","9.5","9.a","9.b","9.c"] },
                { id: "10", targets: ["10.1","10.2","10.3","10.4","10.5","10.6","10.7","10.a","10.b","10.c"] },
                { id: "11", targets: ["11.1","11.2","11.3","11.4","11.5","11.6","11.7","11.a","11.b","11.c"] },
                { id: "12", targets: ["12.1","12.2","12.3","12.4","12.5","12.6","12.7","12.8","12.a","12.b","12.c"] },
                { id: "13", targets: ["13.1","13.2","13.3","13.a","13.b"] },
                { id: "14", targets: ["14.1","14.2","14.3","14.4","14.5","14.6","14.7","14.a","14.b","14.c"] },
                { id: "15", targets: ["15.1","15.2","15.3","15.4","15.5","15.6","15.7","15.8","15.9","15.a","15.b","15.c"] },
                { id: "16", targets: ["16.1","16.2","16.3","16.4","16.5","16.6","16.7","16.8","16.9","16.a","16.b","16.c"] },
                { id: "17", targets: ["17.1","17.2","17.3","17.4","17.5","17.6","17.7","17.8","17.9","17.10","17.11","17.12","17.13","17.14","17.15","17.16","17.17","17.18","17.19"] }
            ]
        };
    },

    methods: {
        // "key exists?" helper (Vue I18n v8 has $te; if not, we just try $t and see if it echoes)
        hasKey(key) {
            if (typeof this.$te === "function") return this.$te(key);
            const val = this.$t(key);
            return val !== key; // if missing, vue-i18n often returns the key
        },

        tTargetName(goalId, targetId) {
            // bracket syntax is REQUIRED for target ids like "6.1"
            const shortKey = `sdgGoalsShort.${goalId}.targets['${targetId}'].name`;
            const longKey  = `sdgGoals.${goalId}.targets['${targetId}'].name`;

            if (this.hasKey(shortKey)) return this.$t(shortKey);
            if (this.hasKey(longKey))  return this.$t(longKey);

            // backward compatible fallback
            return targetId;
        },

        tGoalName(goalId) {
            const shortKey = `sdgGoalsShort.${goalId}.name`;
            const longKey  = `sdgGoals.${goalId}.name`;

            if (this.hasKey(shortKey)) return this.$t(shortKey);
            if (this.hasKey(longKey))  return this.$t(longKey);

            return goalId;
        }
    },

    computed: {
        localizedGoals() {
            return this.goals.map((g) => ({
                id: g.id,
                name: this.tGoalName(g.id),
                targets: g.targets.map((tid) => ({
                    id: tid,
                    number: tid,
                    name: this.tTargetName(g.id, tid),
                })),
            }));
        }
    },



    mounted() {
    }
};
